import { PageType, Product, ProductPageTacticFragmentFragment, useProductTacticsQuery } from '@Generated/graphql'
import { getProductFieldValue } from '@Globals/CMS/FieldHelpers'
import { useHasIntersected } from '@Globals/Hooks/Intersection'

export function useProductTactics(
  productID: string,
  group: Exclude<keyof NonNullable<Product['tactics']>, '__typename'>,
) {
  const [ref, hasIntersected] = useHasIntersected('200px')
  const { data, loading } = useProductTacticsQuery({
    context: {
      domainProxy: true,
      userSpecific: true,
    },
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-only',
    variables: {
      id: productID,
      type: PageType.Product,
    },
    skip: !hasIntersected,
  })

  // @ts-expect-error
  const tactics = getProductFieldValue(data?.page?.fields || [], 'product')?.tactics?.[group] as ProductPageTacticFragmentFragment[] | undefined

  return [
    ref,
    !hasIntersected || loading,
    tactics,
  ] as const
}
